import { FC } from 'react';
import Link from 'next/link';
import Layout from '@/components/layout/Layout';
import PageHeading from '@/components/ui/page-heading/PageHeading';
import Pagination from '@/components/ui/pagination/Pagination';
import AlphabetSearch from '@/components/ui/alphabet-search/AlphabetSearch';
import Breadcrumbs from '@/components/ui/breadcrumbs/Breadcrumbs';
import { useGetUrlPath } from '@/hooks/useGetUrlPath';
import { getAuthorFullName } from '@/helpers/helpers';
import { BOOKS_FOR_PAGE } from '@/helpers/variables';
import { IAuthors, ISearchAuthor } from '@/interfaces/authorsPage.interface';
import styles from './Avtor.module.scss';

interface IAvtor {
  data?: IAuthors;
  letterData?: ISearchAuthor;
}

const Avtor: FC<IAvtor> = ({ data, letterData }) => {
  const pages = data?.total_count || letterData?.total_count;
  const pagesCount = Math.ceil(pages ? pages / BOOKS_FOR_PAGE : 1);

  const currentPath = String(useGetUrlPath());
  const isSearchLetterPage = currentPath.includes('letter');
  const currentPathSplit = currentPath.split('/');

  const getSearchLetterWord = () => {
    if (currentPath.includes('page=')) {
      return currentPathSplit[currentPathSplit.length - 3];
    }
    return currentPathSplit[currentPathSplit.length - 2];
  };

  //Seo block
  const SEO_TITLE = 'Все авторы книг сайта kuchaknig.org';
  const SEO_DESCRIPTION = 'На этой странице можно посмотреть весь список авторов сайта kuchaknig.org.';
  const SEO_CANONICAL = '/avtor/';

  return (
    <Layout title={SEO_TITLE} description={SEO_DESCRIPTION} canonicalHref={SEO_CANONICAL} pageHref={useGetUrlPath()}>
      <Breadcrumbs pageName="Авторы" />
      <PageHeading title="Авторы" />
      <AlphabetSearch url={'/avtor/letter/'} />
      {(!!data?.data && data.data.length > 0) || (letterData?.data && letterData.data.length > 0) ? (
        <>
          <div className={styles.authorsTitle}>Все авторы</div>
          <ul className={styles.authorsList}>
            {data?.data &&
              data.data.length > 0 &&
              data?.data.map((author) => (
                <li key={author.id} className={styles.authorsList__item}>
                  <Link prefetch={false} className={styles.authorsList__link} href={`/avtor/${author.alias}/`}>
                    {getAuthorFullName(String(author.base_author_data.first_name ?? ''), String(author.base_author_data.middle_name ?? ''), String(author.base_author_data.last_name ?? ''))}
                  </Link>
                </li>
              ))}
            {letterData?.data &&
              letterData.data.length > 0 &&
              letterData?.data.map((author) => (
                <li key={author.id} className={styles.authorsList__item}>
                  <Link prefetch={false} className={styles.authorsList__link} href={`/avtor/${author.alias}/`}>
                    {getAuthorFullName(String(author.first_name ?? ''), String(author.middle_name ?? ''), String(author.last_name ?? ''))}
                  </Link>
                </li>
              ))}
          </ul>
        </>
      ) : (
        <div className={`${styles.authorsTitle} ${styles.authorsTitle_mb}`}>{`Авторы не найдены`}</div>
      )}
      {/* Проверка на страницы поиска по букве */}
      {!!isSearchLetterPage ? <Pagination pagesCount={pagesCount ?? 0} postName={`avtor/letter/${getSearchLetterWord()}/page=`} /> : <Pagination pagesCount={pagesCount ?? 0} postName="avtor/page=" />}
      {/* <Breadcrumbs pageName="Авторы" isBottom={true} /> */}
    </Layout>
  );
};

export default Avtor;
